export function formatNumber(n: string) {
  const sanitizedValue = n.replace(/[^0-9.]/g, '').replace(/^0+(?=\d)/, '');
  const parts = sanitizedValue.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}